import { createMD5, createSHA1 } from 'hash-wasm';
import { IHasher } from 'hash-wasm/dist/lib/WASMInterface';

const chunkSize = 64 * 1024 * 1024;
const hashers: {
  MD5: IHasher | null;
  SHA1: IHasher | null;
} = {
  MD5: null,
  SHA1: null,
};

async function hashChunk(hasher: IHasher, chunk: Blob): Promise<void> {
  const fileReader = new FileReader();
  return new Promise<void>((resolve, reject) => {
    fileReader.onload = async (e: ProgressEvent<FileReader>) => {
      const view = new Uint8Array(e.target!.result as ArrayBuffer);
      hasher.update(view);
      resolve();
    };

    fileReader.readAsArrayBuffer(chunk);
  });
}

export const getFileHash = async (file: File | Blob, type: 'MD5' | 'SHA1'): Promise<string> => {
  let hasher: IHasher | null = hashers[type];
  if (hasher === null) {
    hasher = type === 'MD5' ? await createMD5() : await createSHA1();
  } else if (hasher) {
    hasher.init();
  } else {
    throw new Error('Invalid hasher type: MD5 or SHA1 only');
  }

  const chunkNumber = Math.floor(file.size / chunkSize);

  for (let i = 0; i <= chunkNumber; i++) {
    const chunk = file.slice(
      chunkSize * i,
      Math.min(chunkSize * (i + 1), file.size)
    );
    await hashChunk(hasher, chunk);
  }

  const hash = hasher.digest();
  return Promise.resolve(hash);
};
